// extracted by mini-css-extract-plugin
export default {"container":"home-page-quatre95_container__2ze3N","featuredBlock":"home-page-quatre95_featuredBlock__UcH0R","blocks":"home-page-quatre95_blocks__3x16H"};